/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddVisitedFeedRequest,
    CheckFeedUpvoteStatusResponse,
    FeedsResponse,
    UndoUpvoteFeedRequest,
    UndoUpvoteFeedResponse,
    UpvoteFeedRequest,
    UpvoteFeedResponse,
} from '../models';

export interface HomeFeedApiControllerAddVisitedFeedRequest {
    addVisitedFeedRequest: AddVisitedFeedRequest;
}

export interface HomeFeedApiControllerCheckFeedUpvoteStatusRequest {
    feedId: string;
    type: HomeFeedApiControllerCheckFeedUpvoteStatusTypeEnum;
}

export interface HomeFeedApiControllerGetHomeFeedsRequest {
    sessionId?: string;
    pageSize?: number;
    cursor?: string;
    type?: HomeFeedApiControllerGetHomeFeedsTypeEnum;
}

export interface HomeFeedApiControllerUndoUpvoteFeedRequest {
    feedId: string;
    undoUpvoteFeedRequest: UndoUpvoteFeedRequest;
}

export interface HomeFeedApiControllerUpvoteFeedRequest {
    feedId: string;
    upvoteFeedRequest: UpvoteFeedRequest;
}

/**
 * 
 */
export class HomeFeedApi extends runtime.BaseAPI {

    /**
     */
    async homeFeedApiControllerAddVisitedFeedRaw(requestParameters: HomeFeedApiControllerAddVisitedFeedRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.addVisitedFeedRequest === null || requestParameters.addVisitedFeedRequest === undefined) {
            throw new runtime.RequiredError('addVisitedFeedRequest','Required parameter requestParameters.addVisitedFeedRequest was null or undefined when calling homeFeedApiControllerAddVisitedFeed.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/visited-feeds`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addVisitedFeedRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async homeFeedApiControllerAddVisitedFeed(requestParameters: HomeFeedApiControllerAddVisitedFeedRequest): Promise<void> {
        await this.homeFeedApiControllerAddVisitedFeedRaw(requestParameters);
    }

    /**
     */
    async homeFeedApiControllerCheckFeedUpvoteStatusRaw(requestParameters: HomeFeedApiControllerCheckFeedUpvoteStatusRequest): Promise<runtime.ApiResponse<CheckFeedUpvoteStatusResponse>> {
        if (requestParameters.feedId === null || requestParameters.feedId === undefined) {
            throw new runtime.RequiredError('feedId','Required parameter requestParameters.feedId was null or undefined when calling homeFeedApiControllerCheckFeedUpvoteStatus.');
        }

        if (requestParameters.type === null || requestParameters.type === undefined) {
            throw new runtime.RequiredError('type','Required parameter requestParameters.type was null or undefined when calling homeFeedApiControllerCheckFeedUpvoteStatus.');
        }

        const queryParameters: any = {};

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/feeds/{feedId}:upvoteStatus`.replace(`{${"feedId"}}`, encodeURIComponent(String(requestParameters.feedId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async homeFeedApiControllerCheckFeedUpvoteStatus(requestParameters: HomeFeedApiControllerCheckFeedUpvoteStatusRequest): Promise<CheckFeedUpvoteStatusResponse> {
        const response = await this.homeFeedApiControllerCheckFeedUpvoteStatusRaw(requestParameters);
        return await response.value();
    }

    /**
     * Public API
     */
    async homeFeedApiControllerGetHomeFeedsRaw(requestParameters: HomeFeedApiControllerGetHomeFeedsRequest): Promise<runtime.ApiResponse<FeedsResponse>> {
        const queryParameters: any = {};

        if (requestParameters.sessionId !== undefined) {
            queryParameters['sessionId'] = requestParameters.sessionId;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.cursor !== undefined) {
            queryParameters['cursor'] = requestParameters.cursor;
        }

        if (requestParameters.type !== undefined) {
            queryParameters['type'] = requestParameters.type;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/home/feeds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async homeFeedApiControllerGetHomeFeeds(requestParameters: HomeFeedApiControllerGetHomeFeedsRequest): Promise<FeedsResponse> {
        const response = await this.homeFeedApiControllerGetHomeFeedsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async homeFeedApiControllerUndoUpvoteFeedRaw(requestParameters: HomeFeedApiControllerUndoUpvoteFeedRequest): Promise<runtime.ApiResponse<UndoUpvoteFeedResponse>> {
        if (requestParameters.feedId === null || requestParameters.feedId === undefined) {
            throw new runtime.RequiredError('feedId','Required parameter requestParameters.feedId was null or undefined when calling homeFeedApiControllerUndoUpvoteFeed.');
        }

        if (requestParameters.undoUpvoteFeedRequest === null || requestParameters.undoUpvoteFeedRequest === undefined) {
            throw new runtime.RequiredError('undoUpvoteFeedRequest','Required parameter requestParameters.undoUpvoteFeedRequest was null or undefined when calling homeFeedApiControllerUndoUpvoteFeed.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/feeds/{feedId}:undoUpvote`.replace(`{${"feedId"}}`, encodeURIComponent(String(requestParameters.feedId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.undoUpvoteFeedRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async homeFeedApiControllerUndoUpvoteFeed(requestParameters: HomeFeedApiControllerUndoUpvoteFeedRequest): Promise<UndoUpvoteFeedResponse> {
        const response = await this.homeFeedApiControllerUndoUpvoteFeedRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async homeFeedApiControllerUpvoteFeedRaw(requestParameters: HomeFeedApiControllerUpvoteFeedRequest): Promise<runtime.ApiResponse<UpvoteFeedResponse>> {
        if (requestParameters.feedId === null || requestParameters.feedId === undefined) {
            throw new runtime.RequiredError('feedId','Required parameter requestParameters.feedId was null or undefined when calling homeFeedApiControllerUpvoteFeed.');
        }

        if (requestParameters.upvoteFeedRequest === null || requestParameters.upvoteFeedRequest === undefined) {
            throw new runtime.RequiredError('upvoteFeedRequest','Required parameter requestParameters.upvoteFeedRequest was null or undefined when calling homeFeedApiControllerUpvoteFeed.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/feed/{feedId}:upvote`.replace(`{${"feedId"}}`, encodeURIComponent(String(requestParameters.feedId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.upvoteFeedRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async homeFeedApiControllerUpvoteFeed(requestParameters: HomeFeedApiControllerUpvoteFeedRequest): Promise<UpvoteFeedResponse> {
        const response = await this.homeFeedApiControllerUpvoteFeedRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum HomeFeedApiControllerCheckFeedUpvoteStatusTypeEnum {
    Live = 'LIVE',
    Replay = 'REPLAY',
    Preview = 'PREVIEW',
    Review = 'REVIEW',
    PopClip = 'POP_CLIP'
}
/**
    * @export
    * @enum {string}
    */
export enum HomeFeedApiControllerGetHomeFeedsTypeEnum {
    Live = 'LIVE',
    Replay = 'REPLAY',
    Preview = 'PREVIEW',
    Review = 'REVIEW',
    PopClip = 'POP_CLIP'
}
